import {
  ActionTypes,
  SetItemPayloadType,
  SearchContextActions,
  SetActressPayloadType,
} from 'pages/Search/View/Main/types';

export const updateItem: (payload: SetItemPayloadType) => SearchContextActions = (payload) => {
  return {
    type: ActionTypes.SET_ITEM,
    payload,
  };
};

export const setActressInfo: (payload: SetActressPayloadType) => SearchContextActions = (payload) => {
  console.log('pay', payload);
  return {
    type: ActionTypes.SET_ACTRESS,
    payload,
  };
};
